import apiCall from './client';

export async function getFeaturesForAccount(accountId, features) {
  const url = `flipper/api/actors/Account;${accountId}`;
  return await apiCall(url, 'GET');
}
